(function () {
    'use strict';

    angular
        .module('planInitiativeModule')
        .controller('InitiativeUpdateStatusReviewController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'govProcess'];

    function Controller($scope, $state, topBarService, govProcess) {
        topBarService.setTitleAndIcon(govProcess.DisplayName, 'fa fa-compass');

        if (!$state.is('initiativeUpdateStatusReview.noActiveProcess') && !govProcess) {
            $state.go('initiativeUpdateStatusReview.noActiveProcess', {}, { location: 'replace' });
            return;
        }

        // Go To First Initiative To Review
        if ($state.is('initiativeUpdateStatusReview'))  {
            $state.go('initiativeUpdateStatusReview.initiatives.review', {}, { location: 'replace' });
        }
    }

})();